export const formateDate = (date: string | null | undefined) => date && new Date(date).toLocaleDateString('en-US');
